interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = "" }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded-2xl bg-black/5 dark:bg-white/10 ${className}`}
      aria-hidden="true"
    />
  );
}

export function ProductCardSkeleton() {
  return (
    <div className="flex flex-col gap-2 rounded-[16px] border border-black/5 bg-[var(--tg-theme-secondary-bg-color,#f4f4f5)] p-2">
      <Skeleton className="aspect-square w-full rounded-[14px]" />
      <Skeleton className="h-4 w-4/5" />
      <Skeleton className="h-4 w-1/3" />
    </div>
  );
}
